import * as React from 'react';

var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.25 12.004a.75.75 0 0 0-.75-.75H.75a.75.75 0 0 0 0 1.5H16.5a.75.75 0 0 0 .75-.75Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.22 7.724a.75.75 0 0 0 0 1.06l3.22 3.22-3.22 3.22a.75.75 0 0 0 1.06 1.06l3.75-3.75a.75.75 0 0 0 0-1.06l-3.75-3.75a.75.75 0 0 0-1.06 0Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.148 7.411a9.75 9.75 0 1 1-.167 8.86.75.75 0 0 0-1.348.657 11.25 11.25 0 1 0 .191-10.223.75.75 0 0 0 1.324.706Z",
    clipRule: "evenodd"
  })));
};

export { SvgLogin as default };
//# sourceMappingURL=login.svg.js.map
